import { useTLang } from 'intl/intl';

interface Props {
  orderIdFirstDigits: string;
  orderIdLastDigits: string;
  storeName: string;
  totalUnits: number;
}

export function useScheduledOrderInvoiceLang({
  orderIdFirstDigits,
  orderIdLastDigits,
  storeName,
  totalUnits,
}: Props) {
  return {
    orderIdTitle: useTLang(
      { id: 'print.invoice.orderId' },
      { firstDigits: orderIdFirstDigits, lastDigits: orderIdLastDigits },
    ),
    storeName: useTLang(
      { id: 'print.invoice.info.storeName' },
      { name: storeName },
    ),
    platform: useTLang({ id: 'print.invoice.info.platform' }),
    createdAtLabel: useTLang({ id: 'print.invoice.info.createdAt' }),
    placeAtLabel: useTLang({ id: 'scheduleOrder.print.placeAtLabel' }),
    productsTitleP1: useTLang({ id: 'print.invoice.products.title.p1' }),
    productsTitleP2: useTLang(
      { id: 'print.invoice.products.title.p2' },
      { amount: totalUnits },
    ),
    totalLabel: useTLang({ id: 'scheduleOrder.print.totalLabel' }),
    checklistTitleP1: useTLang({ id: 'print.checklist.title.p1' }),
    checklistTitleP2: useTLang(
      { id: 'print.checklist.title.p2' },
      { amount: totalUnits },
    ),
  };
}
